import app from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import firebase from 'firebase'

/* https://firebase.google.com/docs/web/setup */

const config = {
  apiKey: "AIzaSyBckNjnUMokiPp3a9EkosCWqFE9x5rHNWE",
  authDomain: "jit-postcard.firebaseapp.com",
  databaseURL: "https://jit-postcard.firebaseio.com",
  projectId: "jit-postcard",
  storageBucket: "jit-postcard.appspot.com",
  messagingSenderId: "557788815960"
};

app.initializeApp(config);
const settings = { timestampsInSnapshots: true };
const fs = app.firestore();
fs.settings(settings);

const storage = app.storage();

export const img = storage;
export const db = fs;
export const auth = firebase.auth();
export const bauth = firebase.auth;
export const cauth = app.auth;
